var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control"},[_c('control-widgets'),_c('control-panel'),_c('control-config')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }